import ReactGA from 'react-ga'

import { GOOGLE_TRACKING_ID } from '../config'

ReactGA.initialize(GOOGLE_TRACKING_ID)

export function logPageView () {
  ReactGA.set({ page: window.location.pathname + window.location.search })
  ReactGA.pageview(window.location.pathname + window.location.search)
}



// WEBPACK FOOTER //
// ./src/utils/googleAnalytics.js